export const questions = [
  {
    qno: 1,
    question: "Who develop react.js?",
    options: ["Apple", "Facebook", "Twitter", "Google"],
    answer: 2,
  },
  {
    qno: 2,
    question: "Adding the HTML elements, is known to be",
    options: ["Internal", "Inline", "Outline", "External"],
    answer: 2,
  },
  // {
  //     qno: 3,
  //     question: "In HTML elements, CSS can be added in different",
  //     options: ["2 ways", "3 ways", "4 ways", "5 ways"],
  //     answer: 2
  // },
  {
    qno: 3,
    question: "Web browsers makes request of pages from web servers by using a",
    options: ["URL", "Server", "Client", "Medium"],
    answer: 1,
  },
  {
    qno: 4,
    question: "The amount of width required for an inline element is of",
    options: ["Maximum width", "Minimum width", "Necessary width", "No width"],
    answer: 3,
  },
  {
    qno: 5,
    question: "CSS stands for",
    options: [
      "Case Sensitive Sheets",
      "Cascading Style Sheets",
      "Cascading Sensitive Sheets",
      "Case Style Sheets",
    ],
    answer: 2,
  },
  {
    qno: 6,
    question: "What is the use of the <noscript> tag in Javascript?",
    options: [
      "The contents are displayed by non-JS-based browsers",
      "Clears all the cookies and cache",
      "Both A and B",
      "None of the above",
    ],
    answer: 1,
  },
  {
    qno: 7,
    question:
      "When an operator’s value is NULL, the typeof returned by the unary operator is:",
    options: ["Boolean", "Undefined", "Object", "Integer"],
    answer: 3,
  },
  {
    qno: 8,
    question: "How do we write a comment in javascript?",
    options: ["/* */", "//", "#", "$ $"],
    answer: 2,
  },
  {
    qno: 9,
    question: "Which of the following are not server-side Javascript objects?",
    options: ["Date", "FileUpload", "Function", "All of the above"],
    answer: 4,
  },
  {
    qno: 10,
    question: "Which object in Javascript doesn’t have a prototype?",
    options: [
      "Base Object",
      "All objects have a prototype",
      "None of the objects have a prototype",
      "None of the above",
    ],
    answer: 1,
  },
];
